<script>
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'

export default {
  mounted: function () {
    this.loadLocalStorage()
  },
  methods: {
    loadLocalStorage: function () {
      let state = LocalStorageHelper.get(this.localStorageKey)
      if (state) {
        if (state.query) {
          this.querySearch = state.query
        }

        if (state.customQueries) {
          this.customQueries = state.customQueries
        }
      }
    }
  }
}
</script>
